<template>
  <el-dialog
    width="600px"
    title="修改密码"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-form ref="resetPwd" label-width="120px" :rules="rules" :model="form">
      <el-form-item label="账号">
        {{ username }}
      </el-form-item>

      <el-form-item label="旧密码" prop="oldPwd">
        <el-input
          placeholder="3位或以上的字母与数字"
          show-password
          v-model.trim="form.oldPwd"
          width
        >
        </el-input>
      </el-form-item>

      <el-form-item label="新密码" prop="password">
        <el-input
          show-password
          placeholder="新密码"
          auto-complete="new-password"
          autocomplete="new-password"
          v-model.trim="form.password"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="再次输入密码" prop="validPwd">
        <el-input
          show-password
          placeholder="再次输入密码"
          auto-complete="new-password"
          autocomplete="new-password"
          v-model.trim="form.validPwd"
        >
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="goSave">
          确 定
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import * as userApi from '@/service/user'

export default {
  data() {
    return {
      visible: false,
      form: {
        oldPwd: '',
        password: '',
        validPwd: ''
      },
      rules: {
        oldPwd: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 8, max: 32, message: '长度在 8 到 32 个字符', trigger: 'blur' }
        ],
        validPwd: [
          {
            min: 8,
            max: 32,
            message: '长度在 8 到 32 个字符',
            trigger: 'blur'
          },
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: this.checkValid, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    checkValid(rule, value, cb) {
      if (value !== this.form.password) {
        cb(new Error('两次输入密码不一致!'))
      } else {
        cb()
      }
    },
    async goSave() {
      try {
        await new Promise((resolve, reject) => {
          this.$refs.resetPwd.validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject()
            }
          })
        })
        let data = await userApi.resetPwd({
          oldPwd: this.form.oldPwd,
          password: this.form.password
        })
        console.log(data)
        if (data && data.code) {
          this.$alert('修改密码成功，需要重新登录', '提示', {
            confirmButtonText: '确定',
            callback: async () => {
              await this.$store.dispatch('user/resetToken')
              this.$router.replace('/login')
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="css"></style>
